<template>
  <div>
    <template v-if="mode === 'DESIGN'">
      <a-input readOnly :placeholder="placeholder" />
    </template>
    <template v-else>
      <a-popover
        v-model="visible"
        trigger="click"
        placement="bottomLeft"
        v-if="showWithPrompt"
        :getPopupContainer="trigger => trigger.parentNode"
      >
        <template slot="content">
          <div
            class="prompt-item"
            v-for="item in prompts"
            :key="item"
            @click="choiceItem(item)"
          >
            {{ item }}
          </div>
        </template>
        <a-input :disabled="perm === 'R'" v-model="_value" allowClear :placeholder="placeholder" />
      </a-popover>
      <a-input v-else :disabled="perm === 'R'" v-model="_value" allowClear :placeholder="placeholder" />
    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: 'TextInput',
  components: {},
  props: {
    perm: {
      type: String,
      default: '' // R: 只读, E: 编辑, H: 隐藏
    },
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    showWithPrompt: {
      type: Boolean,
      default: false
    },
    prompts: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 默认值
    defaultValue: {
      type: String,
      default: undefined
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      visible: false,
      isInitialized: false // 标记是否已初始化默认值
    }
  },
  watch: {
    // 监听 value 变化，仅在初始化时处理默认值
    value: {
      immediate: true,
      handler(newVal) {
        // 只在非设计模式下且未初始化时处理默认值
        if (this.mode !== 'DESIGN' && !this.isInitialized) {
          // 如果 value 已经有值，标记为已初始化，不再设置默认值
          if (newVal !== undefined && newVal !== null && newVal !== '') {
            this.isInitialized = true
          } else {
            // value 为空，尝试设置默认值
            this.$nextTick(() => {
              this.initDefaultValue()
            })
          }
        }
      }
    },
    // 监听 defaultValue 变化，仅在未初始化时处理
    defaultValue: {
      immediate: true,
      handler() {
        if (this.mode !== 'DESIGN' && !this.isInitialized) {
          this.$nextTick(() => {
            this.initDefaultValue()
          })
        }
      }
    }
  },
  methods: {
    choiceItem(item) {
      this._value = item
      this.visible = false
    },
    /**
     * 初始化默认值
     * 当 value 为空且 defaultValue 存在时，设置默认值
     * 只在组件初始化时执行一次
     */
    initDefaultValue() {
      // 如果已经初始化过，不再处理
      if (this.isInitialized) {
        return
      }

      // 如果已经有值，标记为已初始化，不设置默认值
      if (this.value !== undefined && this.value !== null && this.value !== '') {
        this.isInitialized = true
        return
      }

      // 如果没有默认值，标记为已初始化，不处理
      if (!this.defaultValue || this.defaultValue === '') {
        this.isInitialized = true
        return
      }

      // 设置默认值
      this._value = this.defaultValue
      this.isInitialized = true
    }
  },
  created() {
    // 组件创建时初始化默认值
    if (this.mode !== 'DESIGN') {
      this.$nextTick(() => {
        this.initDefaultValue()
      })
    } else {
      // 设计模式下直接标记为已初始化
      this.isInitialized = true
    }
  }
}
</script>

<style lang="less" scoped>
.prompt-item {
  min-width: 200px;
  padding: 5px 10px;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background-color: #e6f7ff;
  }
}
::v-deep .ant-popover-inner-content {
  max-height: 400px;
  overflow-y: auto;
}
</style>
